module.exports = __webpack_public_path__ + "static/img/4.364fdc53.svg";